import classNames from 'classnames'

interface IProps {
  message?: string
  classes?: string
  hideWhenNotInError?: boolean
}

export const FieldInfoMessage: React.FC<IProps> = ({ message, classes, hideWhenNotInError }) => {
  if (!message) {
    return null
  }

  return <p className={classNames(classes, 'px-2 py-2 text-text-muted/70 text-sm')}>{message}</p>
}
